import {
  NEGOTIATION_LIST_REQUEST,
  NEGOTIATION_LIST_SUCCESS,
  NEGOTIATION_LIST_FAIL,
  NEGOTIATION_ATTEMPT_DELETE_REQUEST,
  NEGOTIATION_ATTEMPT_DELETE_SUCCESS,
  NEGOTIATION_ATTEMPT_DELETE_FAIL,
} from "../constants/negotiationConstants";

export const negotiationListReducer = (state = { negotiations: [] }, action) => {
  switch (action.type) {
    case NEGOTIATION_LIST_REQUEST:
        case NEGOTIATION_ATTEMPT_DELETE_REQUEST:
      return { loading: true, negotiations: [] };
    case NEGOTIATION_LIST_SUCCESS:
        case NEGOTIATION_ATTEMPT_DELETE_SUCCESS:
      return { loading: false, negotiations: action.payload.data };
    case NEGOTIATION_LIST_FAIL:
        case NEGOTIATION_ATTEMPT_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};